export const selectFactoryBagGroups = (state) => state.factoryBagGroups.bagGroups;

export const selectFactoryBagGroupsLoading = (state) => state.factoryBagGroups.loading;
export const selectFactoryBagGroupsError = (state) => state.factoryBagGroups.error;